import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformToYesNo',
  standalone: false
})
export class BooleanToYesNoPipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? 'Yes' : 'No';
  }
}
